import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography
} from "@mui/material";
import React, { useState } from "react";

import { styled } from "@mui/material/styles";
import { withRouter } from "react-router";
import { compose } from "underscore";

import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import { StepLabel } from "../../../components";
import styles from "../styles";

const StyledExpansionPanel = styled(Accordion)(({ theme }) => ({
  border: 0,
  boxShadow: 'none',
  '&:before': {
    display: 'none',
  },
}));

// Styled AccordionSummary
const StyledExpansionPanelSummary = styled(AccordionSummary)(({ theme }) => ({
  padding: '0 16px',
}));

// Styled AccordionDetails
const StyledExpansionPanelDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: '0 16px',
}));

const FAQ = props => {
  const { history } = props;

  const [expanded, setExpanded] = useState(null);

  const handleChangePanel = panel => (event, expanded) => {
    setExpanded(expanded ? panel : false);
  };

  return (
    <div
      style={{
        ...styles.column,
        flex: 1,
        minHeight: "100vh",
        backgroundColor: "#fff"
      }}
    >
      <StepLabel
        title="Frequently Asked Questions"
        onClick={() => history.back()}
        containerStyles={{ padding: "16px 16px 22px" }}
      />
      <div style={{ width: "100%" }}>
        <StyledExpansionPanel
          expanded={expanded === "panel1"}
          onChange={handleChangePanel("panel1")}
        >
          <StyledExpansionPanelSummary
            expandIcon={
              <ExpandMoreOutlinedIcon
                sx={{ cursor: "pointer", color: "#0091DA", fontSize: 24 }}
              />
            }
          >
            <Typography
              color="textPrimary"
              style={{ ...styles.baseFont, fontWeight: "700" }}
            >
              Expansion Panel 1
            </Typography>
          </StyledExpansionPanelSummary>
          <StyledExpansionPanelDetails>
            <Typography
              style={{
                ...styles.baseFont,
                fontSize: "14px",
                lineHeight: 1.29,
                color: "#505050"
              }}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
              eget.
            </Typography>
          </StyledExpansionPanelDetails>
        </StyledExpansionPanel>
        <StyledExpansionPanel
          expanded={expanded === "panel2"}
          onChange={handleChangePanel("panel2")}
        >
          <StyledExpansionPanelSummary
            expandIcon={
              <ExpandMoreOutlinedIcon
                style={{ cursor: "pointer", color: "#0091DA", fontSize: 24 }}
              />
            }
          >
            <Typography
              color="textPrimary"
              style={{ ...styles.baseFont, fontWeight: "700" }}
            >
              Expansion Panel 2
            </Typography>
          </StyledExpansionPanelSummary>
          <StyledExpansionPanelDetails>
            <Typography
              style={{
                ...styles.baseFont,
                fontSize: "14px",
                lineHeight: 1.29,
                color: "#505050"
              }}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
              eget.
            </Typography>
          </StyledExpansionPanelDetails>
        </StyledExpansionPanel>
      </div>
    </div>
  );
};

export default compose(withRouter)(FAQ);
